import type { ConexionPublic } from '@app/shared';

import { api } from '../../../lib/api';

export const conexionesApi = {
  async listar(): Promise<{ conexiones: ConexionPublic[] }> {
    const { data } = await api.get<{ conexiones: ConexionPublic[] }>('/conexiones');
    return data;
  },
  async probar(): Promise<{ conexiones: ConexionPublic[] }> {
    const { data } = await api.post<{ conexiones: ConexionPublic[] }>('/conexiones/probar');
    return data;
  },
};
